<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <form @submit.prevent="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ action }} Country Assignment</p>
        </header>
        <section class="modal-card-body country-assignment">
          <b-field label="Country">
            <b-select
              placeholder="Select a Country"
              :disabled="isView || isEdit"
              v-model="formData.country_id"
              expanded
              required
            >
              <option
                v-for="option in countries"
                :value="option.id"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Reporting Responsible" required>
            <b-select
              placeholder="Select a Reporting Responsible"
              v-model="formData.reporting_responsible_id"
              expanded
              required
              :disabled="isView"
            >
              <option
                v-for="option in usersRR"
                :value="option.id"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Stream" required>
            <multiselect
              :disabled="isView"
              ref="multiselect"
              v-model="streams"
              :options="filteredTags"
              placeholder="Select Streams"
              label="name"
              track-by="name"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :hide-selected="true"
              :show-labels="false"
              data-cy="filter-customers"
              openDirection="below"
              required
            >
              <span
                class="checkbox-label"
                slot="option"
                slot-scope="scope"
                :title="scope.option.name"
              >
                {{ scope.option.name }}
              </span>
            </multiselect>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            class="button is-primary"
            slot="right"
            native-type="submit"
            type="is-primary"
            v-if="action != 'View'"
          >
            {{ action }}
          </b-button>
          <b-button
            class="button is-normal"
            slot="right"
            type="button"
            @click="cancel"
          >
            Cancel
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { UserGroup } from "../../services/UserGroups";
import Multiselect from "vue-multiselect";
import CustomerUpdatesDataService from "../../services/CustomerUpdatesDataService";
// @group Reporting Tracker
export default {
  name: "CountrySupportAssignment",
  components: { Multiselect },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    customers: [],
    users: [],
    containers: [],
    countries: [],
    editData: {
      type: Object,
      default: () => {
        return {
          country_id: null,
          streams: [],
          reporting_responsible_id: null
        };
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: "Add"
    }
  },
  data() {
    return {
      usersRR: [],
      formData: [],
      streams: [],
      filteredTags: [],
      isModalActive: false,
      selectedCAMUser: null,
      selectedCutomerScope: null,
      selectedStream: null,
      selectedCountry: null,
      selectedCAM: null,
      customerUpdatesDataService: new CustomerUpdatesDataService()
    };
  },

  watch: {
    editData(newValue) {
      this.formData = newValue;
      //this.updateCustomers();
      if (newValue.streams) {
        this.streams = this.filteredTags.filter(item =>
          newValue.streams.includes(item.id)
        );
      } else {
        this.streams = [];
      }
    },
    containers(newValue) {
      this.filteredTags = newValue;
    },
    users(newValue) {
      this.fetchUsers(newValue);
    },
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  },
  methods: {
    cancel() {
      this.isModalActive = false;
      this.$emit("cancle");
    },

    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    },
    fetchUsers(newValue) {
      //  filter users based onn groups
      this.usersRR = this.filterUsers(
        newValue,
        UserGroup.REPORTING_RESPONSIBLE
      );
    },

    submit() {
      if (this.streams.length > 0) {
        this.formData["streams"] = this.streams.map(a => a.id);
        this.$emit("submit", this.formData);
      } else {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select at least one stream",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    }
  }
};
</script>
<style scoped>
/* Make the modal taller and allow more space for dropdowns */
.country-assignment {
  padding-bottom: 150px;
}
</style>
